import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Role, RoleList } from '../pages/permissions/permissions.entities';

@Injectable({
  providedIn: 'root',
})
export class RoleService {
  constructor(private httpClient: HttpClient) {}

  getRole(roleId: string) {
    return this.httpClient.get<Role>(`/bff/v1/roles/${roleId}`);
  }

  createRole(role: Partial<Role>): Observable<Role> {
    return this.httpClient.post<Role>('/bff/v1/roles', role);
  }

  listRoles() {
    return this.httpClient.get<RoleList>('/bff/v1/roles');
  }

  updateRole(id: string, role: Partial<Role>): Observable<Role> {
    return this.httpClient.put<Role>(`/bff/v1/roles/${id}`, role);
  }
}
